// home
import axios from './axios.js'

// 查询门店列表数据
export function queryStoresDataSeach(limit, page, categoryId, shopName, dutyPhone, merchantsId) {
    return axios.get(`/mall/shop/list_data_v2?limit=${limit}&page=${page}&categoryId=${categoryId}&shopName=${shopName}&dutyPhone=${dutyPhone}&merchantsId=${merchantsId}`)
}

//门店列表-修改编辑
export function modifyEdit(data) {
    return axios.post(`/mall/shop/edit`, data)
}

// 审核数据  通过
export function examineAdopt(data) {
    return axios.post(`/settle_distribution/settle`, data)
}

// 审核数据  不通过
export function examineFail(data) {
    return axios.post(`/settle_distribution/settle`, data)
}

// 分销商代理审核-查询
export function queryExamine(data) {
    return axios.post(`/settle_distribution/page`, data)
}

//订单管理-秒杀订单列表
export function seckillList(data) {
    return axios.post(`/order_mall/list_data_spike`, data)
}
//门店删除
export function delList(uid, shopId) {
    return axios.get(`/mall/shop/del?uid=${uid}&shopId=${shopId}`)
}
//门店密码修改
export function resetpswList(uid, password) {
    return axios.post(`/account_login_check/edit_shop_password?uid=${uid}&password=${password}`)
}

// export function seckillList(page,limit) {
//     return axios.get(`/order_mall/list_data_spike?page=${page}&limit=${limit}`)
// }

// 订单管理-门票套餐订单
export function ticketList(limit, page, goodsTypeSonId,uids, orderNo, shopId, endDate, startDate) {
    return axios.get(`/order_mall/list_data?limit=${limit}&page=${page}&goodsTypeSonId=${goodsTypeSonId}&userUid=${uids}&orderNo=${orderNo}&shopId=${shopId}&endDate=${endDate}&startDate=${startDate}`)
}
// 订单管理-门票套餐订单搜索
export function ticketListSeach(limit, page, goodsTypeSonId, uids, orderNo, shopId, endDate, startDate) {
    return axios.get(`/order_mall/list_data?limit=${limit}&page=${page}&goodsTypeSonId=${goodsTypeSonId}&userUid=${uids}&orderNo=${orderNo}&shopId=${shopId}&endDate=${endDate}&startDate=${startDate}`)
}

// 代币套餐订单列表-查询
export function querypackage(limit, page, goodsTypeSonId, orderNo, uid) {
    return axios.get(`order_mall/list_data?limit=${limit}&page=${page}&goodsTypeSonId=${goodsTypeSonId}&orderNo=${orderNo}&userUid=${uid}`)
}

// 门票套餐订单列表-查询
export function queryticket(limit, page, goodsTypeSonId, orderNo, uid) {
    return axios.get(`order_mall/list_data?limit=${limit}&page=${page}&goodsTypeSonId=${goodsTypeSonId}&orderNo=${orderNo}&userUid=${uid}`)
}

// 砍价订单列表-查询
export function queryOrder(data) {
    return axios.post('/order_mall_cut/list_data', data)
}

// 获取拼团订单列表
export function getGroupList(limit, page) {
    return axios.get(`/order_mall_pt/list_data?limit=${limit}&page=${page}`)
}
// 获取拼团订单列表搜索
export function getGroupListSeach(page, limit, orderNo, userUid, shopId, endTime, beginTime) {
    return axios.get(`/order_mall_pt/list_data?page=${page}&limit=${limit}&orderNo=${orderNo}&userUid=${userUid}&shopId=${shopId}&endTime=${endTime}&beginTime=${beginTime}`)
}
// 获取拼团成员
export function getmGroupMmber(data) {
    return axios.post(`/order_mall_pt/list_data_all`, data)
}

// 订单详情
export function getoOderDetails(orderNo) {
    return axios.get(`/order_mall/info?orderNo=${orderNo}`)
}

// 兑换订单详情
export function getExchangeOderDetails(orderNo) {
    return axios.get(`/order_lottery/info?orderNo=${orderNo}`)
}

// 财务管理-订单收入
export function getOrdeRrevenue(page, limit) {
    return axios.get(`/finance_order/list_data?page=${page}&limit=${limit}`)
}



// WEBPACK FOOTER //
// ./src/api/hometwoApi.js